var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    {
      staticClass: "moregage-form",
      attrs: { "body-class": "pt-sm-1 pt-lg-4" },
    },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { staticClass: "order-lg-1 order-2", attrs: { lg: "10" } },
            [_vm._t("content")],
            2
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass:
                "column-divider-left order-lg-2 order-1 d-lg-flex flex-column align-items-center justify-content-center",
              attrs: { lg: "2" },
            },
            [
              _c("p", { staticClass: "bold text-gray text-uppercase my-3" }, [
                _vm._v("\n        " + _vm._s(_vm.name) + "\n      "),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }